
import type { PropOptions } from 'vue';
import Vue from 'vue';
import BackIconSvg from './images/back.vue.svg';
import CloseIconSvg from './images/close.vue.svg';

export default Vue.extend({
  name: 'BravadoTypeformRight',
  components: {
    BackIconSvg,
    CloseIconSvg,
  },
  props: {
    showBackButton: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
    showCloseButton: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
    autofocus: {
      type: Boolean,
      default: true,
    } as PropOptions<boolean>,
  },
  computed: {
    rootClasses(): Record<string, boolean> {
      return {
        'bravado-typeform-right': true,
        'bravado-typeform-right--with-header': !!this.$slots.header,
      };
    },
  },
  mounted() {
    if (this.autofocus) this.handleAutofocus();
  },
  methods: {
    handleAutofocus() {
      let counter = 0;
      const interval = window.setInterval(() => {
        counter++;

        if (counter > 20) {
          window.clearInterval(interval);
        }

        if (this.$refs.content) {
          let inputEl = (this.$refs.content as HTMLElement).querySelector('input[type="text"]') as HTMLElement;
          if (!inputEl) {
            inputEl = (this.$refs.content as HTMLElement).querySelector('textarea') as HTMLElement;
          }

          if (inputEl) {
            try {
              const tempEl = document.createElement('input') as HTMLElement;
              tempEl.style.position = 'absolute';

              tempEl.style.top = inputEl.offsetTop + 7 + 'px';
              tempEl.style.left = inputEl.offsetLeft + 'px';

              tempEl.style.height = '0';
              tempEl.style.opacity = '0';

              inputEl.parentElement?.appendChild(tempEl);

              tempEl.focus();

              setTimeout(() => {
                inputEl.focus();
                inputEl.parentElement?.removeChild(tempEl);
              }, 200);

              window.clearInterval(interval);
            } catch (e) {
              this.$sentryUtils.error(e);
            }
          }
        }
      }, 100);
    },
  },
});
